import './card-horizontal.scss'
// components
import Card from '../../../atoms/card/card'
import Image from '../../../atoms/Image/image'
import Button from '../../../atoms/button/button'
// icons
import { CalendarIcon, ClockIcon } from '../../../atoms/icons'

const CardHorizontal = props => {
	const {
		img,
		title,
		buttonText,
		hour,
		date,
		onClick,
		customStiles = { title: {}, hour: {} },
		withBorder = false
	} = props

	return (
		<Card classes={`m-card-horizontal ${withBorder && 'border'}`}>
			<Image classes='m-card-horizontal__img' src={img} alt='' width='105' height='130' />
			<div className='m-card-horizontal__body'>
				{title && <h4 style={customStiles.title}>{title}</h4>}
				{date && (
					<p>
						<CalendarIcon color='#6f7287' />
						{date}
					</p>
				)}
				{hour && (
					<p style={customStiles.hour}>
						<ClockIcon color='#6f7287' />
						{hour}
					</p>
				)}
				{buttonText && (
					<Button
						onClick={onClick || null}
						title={buttonText}
						uppercase
						classes='pink small fit mt1'
					/>
				)}
			</div>
		</Card>
	)
}

export default CardHorizontal
